import algoliaSearch from '../src/algolia_search/search'
import initStickyMobileCtas from '../libs/search/stickyMobileCtas'

document.addEventListener('DOMContentLoaded', () => {
  algoliaSearch()
  initStickyMobileCtas()
})
